module.exports = __webpack_public_path__ + "img/TKTK.a0a59ee2.svg";